import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { SavePathUserBody } from "./models";

export const getUserSetup = createAsyncThunk(
  "userSetup/getUserSetup",
  async (data: {
    idUsuario: string;
    pagina: number;
    itensPorPagina: number;
  }) => {
    const { idUsuario, pagina, itensPorPagina } = data;
    let response: any;
    try {
      response = await API.get(`/user-setup/${idUsuario}`, {
        params: { pagina, itensPorPagina },
      });
    } catch (err) {
      console.error(err);
    }
    return response.data;
  }
);

export const savePathUser = createAsyncThunk(
  "userSetup/savePathUser",
  async (data: SavePathUserBody) => {
    try {
      await API.post("/rastreio/acesso/sensivel", data);
    } catch (err) {
      console.error(err);
    }
  }
);
